import { Injectable } from '@angular/core';
import { DatabaseConnection } from '../../shared/services/database-connection';
import { HttpClient } from '@angular/common/http';
import { Groupe } from '../model/groupe';

@Injectable({
  providedIn: 'root',
})
export class GroupeService {

    end_url = 'groupe'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

    getAll(){
      return this.http.get<Groupe[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
    }

    get(Groupe : string){
      return this.http.get<Groupe>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + Groupe)
    }

    create(data : any){
      return this.http.post<Groupe>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
    }

    update(data : any, id : string){
      return this.http.put<Groupe>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
    }

    delete(id : string){
      return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
    }

    changeStatus(id : string){
      return this.http.get<Groupe>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
    }
}
